/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/loket?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async detail({}, payload) {
    const url = `/loket/${payload}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/loket`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/loket/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/loket/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/loket/${payload.id}`;
    return http.delete(url);
  },
};
